module.exports = __webpack_public_path__ + "assets/img/66947539a1437ab65b0a5f2e6f9f2957.webp";